export default "__VITE_ASSET__BUHbmyRU__"